var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLeftbarMenuicon = function SvgLeftbarMenuicon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.4V12.6C12 12.2686 12.2686 12 12.6 12H18.4C18.7314 12 19 12.2686 19 12.6V18.4C19 18.7314 18.7314 19 18.4 19H12.6C12.2686 19 12 18.7314 12 18.4Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 18.4V12.6C1 12.2686 1.26863 12 1.6 12H7.4C7.73137 12 8 12.2686 8 12.6V18.4C8 18.7314 7.73137 19 7.4 19H1.6C1.26863 19 1 18.7314 1 18.4Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.4V1.6C12 1.26863 12.2686 1 12.6 1H18.4C18.7314 1 19 1.26863 19 1.6V7.4C19 7.73137 18.7314 8 18.4 8H12.6C12.2686 8 12 7.73137 12 7.4Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7.4V1.6C1 1.26863 1.26863 1 1.6 1H7.4C7.73137 1 8 1.26863 8 1.6V7.4C8 7.73137 7.73137 8 7.4 8H1.6C1.26863 8 1 7.73137 1 7.4Z",
    stroke: "black",
    strokeWidth: 1.5
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeftbarMenuicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LeftbarMenuicon.3ce9e705.svg";
export { ForwardRef as ReactComponent };